import { useLocation } from 'react-router';
import { parse, stringify } from 'query-string';

export const useBRToolParameter = (): string => {
  const { hash } = useLocation();
  const { 'br-exp': brExp, esExp, suggestArticle } = parse(hash);
  return stringify({ brExp, esExp, suggestArticle });
};

export default useBRToolParameter;
